import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiTarget, FiUsers, FiSettings, FiDollarSign } = FiIcons;

const HeroSection = () => {
  return (
    <section className="hero-section bg-gradient-to-br from-blue-900 via-blue-800 to-navy-900 text-white py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            className="text-content"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Launch Your Own <span className="text-yellow-400">AI Software Company</span> in 7 Days & Build <span className="text-green-400">₹1 Crore+/Year</span> Recurring Income
            </h1>
            
            <p className="text-xl md:text-2xl text-blue-200 mb-8 leading-relaxed">
              Get personal 1-to-1 consulting and done-with-you implementation from Abdul Hakkim and his team – even if you're not technical.
            </p>

            <div className="benefits-list mb-10 space-y-4">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiTarget} className="text-green-400 text-2xl" />
                <span className="text-lg">Launch your AI software company in 7 days</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiUsers} className="text-green-400 text-2xl" />
                <span className="text-lg">Start signing clients at ₹5,000–₹25,000/month each</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiTrendingUp} className="text-green-400 text-2xl" />
                <span className="text-lg">Build predictable recurring income instead of one-time sales</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiSettings} className="text-green-400 text-2xl" />
                <span className="text-lg">Get templates, systems, and a team to implement with you</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiDollarSign} className="text-green-400 text-2xl" />
                <span className="text-lg">Scale to multi-crore recurring revenue streams</span>
              </div>
            </div>

            <motion.a
              href="https://abdul.cc/earnwithabdul"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-bold text-xl px-12 py-6 rounded-full hover:from-yellow-500 hover:to-yellow-700 transition-all duration-300 transform hover:scale-105 shadow-2xl"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Apply Now – Limited to 5 Seats
            </motion.a>

            <p className="text-red-300 text-sm mt-4 font-semibold">
              Only 5 seats per month. 1 taken, 4 left.
            </p>
          </motion.div>

          <motion.div 
            className="visual-content"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
              <div className="space-y-6">
                <div className="flex items-center justify-between bg-green-500/20 p-4 rounded-lg">
                  <span className="text-green-300">Monthly Recurring Revenue</span>
                  <span className="text-2xl font-bold text-green-400">₹5.2L+</span>
                </div>
                <div className="flex items-center justify-between bg-blue-500/20 p-4 rounded-lg">
                  <span className="text-blue-300">Annual Revenue Target</span>
                  <span className="text-2xl font-bold text-blue-400">₹1.37 Cr</span>
                </div>
                <div className="flex items-center justify-between bg-yellow-500/20 p-4 rounded-lg">
                  <span className="text-yellow-300">Implementation Time</span>
                  <span className="text-2xl font-bold text-yellow-400">7 Days</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;